const isNarrow = () => {
  return (document.body.clientWidth < 700);
}

export default isNarrow;